import React from 'react';

import { errorMessage } from '../../services/apiError';

export const handleConnectionSubmit = async (
  e: React.FormEvent,
  repoUrl: string,
  username: string,
  token: string,
  createRepoIfMissing: boolean,
  setError: (msg: string | null) => void,
  onConnect: (repoUrl: string, username: string, token: string, createRepoIfMissing: boolean) => Promise<void>
) => {
  e.preventDefault();
  if (!repoUrl) {
    setError('Repository URL is required.');

    return;
  }

  try {
    setError(null);
    await onConnect(repoUrl, username, token, createRepoIfMissing);
  } catch (err: unknown) {
    setError(errorMessage(err, 'We couldn’t connect this repository. Check the URL and credentials.'));
  }
};
